/**
 * 任意の年が閏年であるかをチェックする
 * @param {number} チェックしたい西暦年号
 * @return {boolean} 閏年であるかを示す真偽値
 */
const isLeapYear = (year) =>
  (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

/**
 * 任意の年の2月の日数を数える
 * @param {number} チェックしたい西暦年号
 * @return {number} その年の2月の日数
 */
const countDatesOfFeb = (year) => (isLeapYear(year) ? 29 : 28);

export const getDateArray = (year) => [
  31,
  countDatesOfFeb(year),
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31,
];

export const range = (start, stop, step = 1) =>
  Array(Math.ceil((stop - start) / step))
    .fill(start)
    .map((x, y) => x + y * step);
